// extracted by mini-css-extract-plugin
export var basicSlider = "basicSlider-module--basic-slider--ee10a";
export var nextButton = "basicSlider-module--nextButton--c5a5a";
export var prevButton = "basicSlider-module--prevButton--fe867";
export var slide = "basicSlider-module--slide--70627";
export var sliderWrapper = "basicSlider-module--slider-wrapper--05386";